import { render, staticRenderFns } from "./tpl.vue?vue&type=template&id=28ff882e&"
import script from "./tpl.vue?vue&type=script&lang=ts&"
export * from "./tpl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports